import { Text } from '../../../../../cdl/Text/Text';
import { translate } from '../../../../../common/helpers/translate.helper';
import { Box } from '../../../../../common/ui/Box';
import { EnquiryType, OfferModel } from '../../../../../offer/model/OfferModel';
import { useOfferCardContext } from '../../../components/OfferCard/hooks/useOfferCardContext';

const getAssignedOfferLabel = (offer: OfferModel): string | null => {
    switch (offer.enquiryType) {
        case EnquiryType.ASSIGNED:
        case EnquiryType.FORWARDED:
            return offer.lubesContract?.name ?? translate('labelList.contracted');
        default:
            return null;
    }
};

const getForwardedLabel = (offer: OfferModel): string | null => {
    switch (offer.enquiryType) {
        case 'FORWARDED':
            return translate('labelList.forwarded');
        default: {
            return null;
        }
    }
};

const getTypeLabel = (offer: OfferModel): string | null => {
    if (offer.isForwarded()) {
        return null;
    }

    switch (offer.supplier.supplierGroup.type) {
        case 'MANUFACTURER': {
            return translate('labelList.manufacturer');
        }
        case 'DISTRIBUTOR': {
            return translate('labelList.distributor');
        }
        case 'TRADER': {
            return translate('labelList.trader');
        }
        default:
            return null;
    }
};

export const OfferLabelList = () => {
    const { offer } = useOfferCardContext();

    const labels = [getTypeLabel(offer), getAssignedOfferLabel(offer), getForwardedLabel(offer)]
        .filter((label) => label !== null)
        .map((label) => (
            <Text
                key={label}
                variant="extraSmall"
                color="foreground.muted"
                style={{
                    maxWidth: 200,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
            >
                {label}
            </Text>
        ));

    return (
        <Box display="flex" columnGap={8}>
            {labels}
        </Box>
    );
};
